import React from "react";
import { Button, Modal } from "antd";
import Spinner from "./spinner";
import { cn } from "../../utils/cn";

const CommonDialog = ({
  title,
  open,
  setOpen,
  onOk,
  onCancel,
  children,
  description,
  isConfirmButtonLoading,
  okButtonTitle = "Confirm",
  className = "",
  contentClassName = "",
  footer // Optional prop to override or hide footer
}) => {
  // Default footer if not provided
  const defaultFooter = [
    <Button
      key="cancel"
      className="h-10 min-w-[100px] hover:!border-primary hover:!text-primary"
      onClick={onCancel}
      disabled={isConfirmButtonLoading}
    >
      Cancel
    </Button>,
    <Button
      key="confirm"
      type="primary"
      className="!bg-primary text-white h-10 min-w-[130px]"
      onClick={onOk}
      disabled={isConfirmButtonLoading}
    >
      {isConfirmButtonLoading && <Spinner className={"!border-white"} />}{okButtonTitle}</Button>,
  ];

  return (
    <Modal
      centered
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      className={cn(className)}
      footer={footer !== undefined ? footer : defaultFooter}
      classNames={{
        content: cn("max-h-[600px] overflow-y-auto overflow-x-hidden !rounded-md w-full", contentClassName)
      }}
    >
      <div className="space-y-2 w-full">
        <p className="text-lg font-medium">
          {title}
          <span className="text-sm text-secondary block font-normal">
            {description}
          </span>
        </p>
        {children}
      </div>
    </Modal>
  );
};

export default CommonDialog;
